import React from 'react';

export default function LeaveIcon({ active = false, size = 22, ...props }) {
  const stroke = active ? 'rgba(255,215,0,0.9)' : 'rgba(255,215,0,0.6)';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Circle */}
      <circle cx="12" cy="12" r="9" stroke={stroke} strokeWidth="1.6" />
      {/* X */}
      <line x1="9" y1="9" x2="15" y2="15" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" />
      <line x1="15" y1="9" x2="9" y2="15" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}
